<!--
  a11y: (ngSubmit) intercepts the form's submit event so pressing Enter or
  the mobile keyboard "Search" key inside any input (e.g. POI combobox)
  doesn't trigger the browser's default GET submission, which would reload
  the page and re-open the underlying address-map overlay (whose H2
  "Search Address" is the first heading in the DOM - audit symptom).
  Angular's ngSubmit directive automatically calls preventDefault before
  emitting; the bound handler is the same submitRoutePlannerForm() the
  external "Find Station" button calls, so behaviour is identical for both
  activation paths.
-->
<form
  [formGroup]="routePlannerForm"
  class="route-planner-form h-full"
  [class]="direction"
  (ngSubmit)="submitRoutePlannerForm()"
>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col h-full w-full gap-4">
      <div class="flex flex-col gap-4 bg-white rounded-b-xl p-4 shadow-lg">
        <mot-button-toggle formControlName="searchType" toggleClass="flex-1" class="w-full"
          [options]="searchStationsOptions" [groupAriaLabel]="searchTypeRadioGroupLabel" />

          @switch (routePlannerForm.controls['searchType'].value) {
            @case (eSearchStationsOptions.STATION) {
              <div class="flex flex-col gap-1">
                <mot-autocomplete formControlName="stop" [readOnly]="true" [displayErrors]="false" appearance="fill"
              inputClass="hidden" [label]="searchByStationLabelText" (onClick)="
              openAutocomplete(getFormControl('stop'), stationSearchingText, 'stop')
              " fieldClass="cursor-pointer bg-transparent w-full !text-default" [hasTrigger]="true">
                  @if (!!getFormControl('stop').value) {
                    <div trigger>
                      <span>{{ getStopName() }}</span>
                      <!-- contrast: tailwind config text-gray-600 (~2.6:1) fails AA; subText (~4.9:1) passes. -->
                      <small class="text-subText">
                      - {{ getFormControl("stop").value?.stopcode }}</small>
                    </div>
                  }
                </mot-autocomplete>
                <div class="flex items-center">
                  <ng-icon [name]="'circle-info'" class="text-2xl text-[#5C748F]" />
                  <span class="text-xs text-[#5C748F] font-normal mt-1">{{searchByText}} {{searchByStationLabelText}}</span>
                </div>
              </div>
            }
            @case (eSearchStationsOptions.POI) {
              <mot-autocomplete formControlName="poi" [displayErrors]="false"
                appearance="fill" [label]="searchByPoiLabelText" fieldClass="bg-transparent w-full !text-default"
                [displayFn]="routePlanningService.displayPoiName" [options]="pointsOfInterestOptions$">
                <ng-template #customOption let-option>
                  <div class="flex flex-col pb-1">
                    <div class="flex items-center gap-1">
                      <ng-icon name="map-location-dot" class="text-2xl"></ng-icon>
                      <span>{{ option.value.name }}</span>
                    </div>
                    <small class="text-sm font-normal text-[#5C748F]">{{getPoiSub(option.value)}}</small>
                  </div>
                </ng-template>
              </mot-autocomplete>
              @if (poiEmptyResults) {
                <button
                  type="button"
                  class="flex gap-2 rounded bg-transparent p-0 text-start border-0 text-inherit w-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0C3058]"
                  [class.cursor-pointer]="!missingSearchSentViaButton"
                  [class.opacity-60]="missingSearchSentViaButton"
                  [disabled]="missingSearchSentViaButton"
                  (click)="sendMissingSearch()"
                  >
                  <ng-icon class="text-base shrink-0" [name]="missingSearchSentViaButton ? 'check' : 'plus'" aria-hidden="true" />
                  <span>{{ missingSearchSentViaButton ? poiRequestSentText : askPoiText }}</span>
                </button>
              }
            }
          }
        </div>

        <!-- Display NoResultsComponent when there's an error -->
        @if (hasError) {
          <app-no-results [noResultsForWhatText]="errorMessage"></app-no-results>
        }

      </div>
      <app-favorite-stations (onFavoriteStationClick)="handleFavoriteStationClick($event)" class="w-full" />
    </div>
  </form>